import { useEffect } from 'react'

/**
 * Lisää modaalin taustan (overlay) klikkaukseen close-toiminnon.
 * Suomi.fi:n Modal-komponentti ei vie react-modalin
 * shouldCloseOnOverlayClick-proppia läpi, joten klikkaus pohjaan
 * lisätään document-tasolla overlay-elementin classin perusteella.
 *
 * Käyttö:
 *   useModaaliBackdropSulku(visible, onClose)
 *
 * Klikkaus modaalin SISÄLLÄ ei sulje — vain klikkaus suoraan
 * `.fi-modal_overlay`-elementtiin laukaisee close:n.
 */
export function useModaaliBackdropSulku(
  visible: boolean,
  onClose: () => void,
) {
  useEffect(() => {
    if (!visible) return
    function handleClick(e: MouseEvent) {
      const target = e.target as HTMLElement
      if (target.classList.contains('fi-modal_overlay')) {
        onClose()
      }
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [visible, onClose])
}
